import React from 'react';
import './LoginHome.css';
import UserDots from '../menubar/UserDots';
import MenuItems from '../menubar/MenuItems';
import MobileMenuBar from '../menubar/MobileMenuBar';
import { Box, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import Logo from '../menubar/Logo'
import useMediaQuery from "@mui/material/useMediaQuery";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "transparent",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
}));

function LoginHome() {
       const isMobile = useMediaQuery("(max-width:768px)");
    return (
        <Box
                className="login-container"
                style={{
                    backgroundImage: `url('/choppies/assets/${isMobile ? "homepagemobile.png" : "homepage.png"}')`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center top",
                    backgroundSize: "cover",
                    width: "100vw",
                    height: "100vh"
                }}
            >
    
            <Grid container spacing={0} className="login-bg">
                <Grid item xs={12} className="login-content">
                  

                    {/* Main Section */}
                    <Item className="main-section">
                    {isMobile ? (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <MobileMenuBar />
                        </div>
                    ) : (
                        <>
                            {/* Header Section */}
                            <Logo />

                            <div className="p-menu-section">
                                <MenuItems />
                            </div>

                            <div className="user-section">
                                <UserDots />
                            </div>
                        </>
                    )}
                </Item>

                </Grid>
            </Grid>
        </Box>
    );
}

export default LoginHome;
